export default __webpack_public_path__ + "static/media/mobile.173bf5f2.svg";